import BaseComponent from 'primevue/basecomponent';

var script = {
  name: 'Row',
  "extends": BaseComponent,
  render: function render() {
    return null;
  }
};

export { script as default };
